import type { Options as KyOptions } from 'ky';
import { endpoints } from './generated';
import { createKyAliasClient, type StoxlyRefreshOptions } from './ky-runtime';
import type { StoxlyClient } from './op-types';

export interface StoxlyClientOptions {
  /** Origin only, e.g. `http://localhost:3000` — generated paths already include the `/api` prefix. */
  baseUrl: string;
  /** Returns the current access token; attached as `Authorization: Bearer <token>` on every request. */
  getToken?: () => string | null | Promise<string | null>;
  /** Enables 401 refresh-and-retry. The client has no auth-provider knowledge — the app injects it. */
  refresh?: StoxlyRefreshOptions;
  /** Extra ky options: hooks, `fetch` override (Expo/Electron), timeout, transport retry. */
  kyOptions?: Omit<KyOptions, 'method' | 'prefixUrl'>;
}

export function createStoxlyClient(options: StoxlyClientOptions): StoxlyClient {
  return createKyAliasClient(endpoints, options) as unknown as StoxlyClient;
}
